import React, { createContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getApiUrl } from "./utils/api";

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [loginState, setLoginState] = useState(false);
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const storedUser = sessionStorage.getItem("user");
    if (storedUser) {
      try {
        const parsedUser = JSON.parse(storedUser);
        setUser(parsedUser);
        setLoginState(true);
      } catch (error) {
        console.error("Error parsing stored user:", error);
        sessionStorage.removeItem("user");
      }
    }
  }, []);

  // NEW: Method to refresh/update user data from server
  const refreshUser = async () => {
    try {
      const response = await fetch(getApiUrl("/api/user/profile"), {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (response.ok) {
        const data = await response.json();
        if (data.status === "success" && data.profile) {
          const updatedUser = data.profile;
          // Preserve TA "Course Manager" choice (client-only); server profile does not include effectiveRole
          const taManagerMode = typeof sessionStorage !== "undefined" && sessionStorage.getItem("ta_manager_mode") === "true";
          if (taManagerMode && updatedUser.role === "student") {
            updatedUser.effectiveRole = "manager";
          }
          if (updatedUser.role !== "student") {
            sessionStorage.removeItem("ta_manager_mode");
          }
          setUser(updatedUser);
          setLoginState(true);
          sessionStorage.setItem("user", JSON.stringify(updatedUser));
          return updatedUser;
        }
      } else if (response.status === 401 || response.status === 403) {
        // If unauthorized, clear user data
        setUser(null);
        setLoginState(false);
        sessionStorage.removeItem("user");
        sessionStorage.removeItem("ta_manager_mode");
        return null;
      }
    } catch (error) {
      console.error("Error refreshing user data:", error);
      return null;
    }
  };

  // NEW: Method to update user data without API call (for immediate UI updates)
  const updateUser = (updatedUserData) => {
    setUser(updatedUserData);
    setLoginState(true);
    sessionStorage.setItem("user", JSON.stringify(updatedUserData));
  };

  const logout = () => {
    setUser(null);
    setLoginState(false);
    sessionStorage.removeItem("user");
    sessionStorage.removeItem("ta_manager_mode");
    fetch(getApiUrl("/api/logout"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify({}),
    }).catch((error) => {
      console.error("Logout error:", error);
    });
    // Redirect to homepage
    navigate("/");
  };

  return (
    <UserContext.Provider
      value={{
        loginState,
        setLoginState,
        user,
        setUser,
        logout,
        refreshUser, // NEW
        updateUser, // NEW
      }}
    >
      {children}
    </UserContext.Provider>
  );
};
